import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "./components/Dashboard";
import Map from "./components/Map";
import ExplorerMap from "./components/ExplorerMap";
import CompartirMapa from "./components/CompartirMapa";
import ExplorerMapUser from "./components/ExplorerMapUser";
import ExplorerProjectMapUser from "./components/ExplorerProjectMapUser";
import FormList from "./components/FormList";
import FormBuilder from "./components/FormBuilder";
import FormEditBuilder from "./components/FormEditBuilder";
import FormAnswers from "./components/FormAnswers";
import UserList from "./components/UserList";
import GuestUserList from "./components/GuestUserList";
import MonitorsList from "./components/MonitorsList";
import PlacesList from "./components/PlacesList";
import Login from "./components/Login.vue";
import EventsList from "./components/EventsList";
import ComplaintsList from "./components/ComplaintsList";
import Reports from "./components/Reports";
import Config from "./components/Config";
import PasswordChange from "./components/PasswordChange";
import Privacy from "./components/Privacy";
import Support from "./components/Support";
import AlertList from "./components/AlertList";
import RaisingList from "./components/RaisingList";
import UserRaisingList from "./components/UserRaisingList";
import Register from "./components/Register";
import LevantamientosStatistics from "./components/LevantamientosStatistics";
import LevantamientosStatisticsUser from "./components/LevantamientosStatisticsUser";
import ProjectsList from "./components/ProjectsList";
import ProjectsListAll from "./components/ProjectsListAll";
import ProjectEvalueList from "./components/ProjectEvalueList";
import DownloadList from "./components/DownloadList";
import DownloadEvaluationList from "./components/DownloadEvaluationList";
import Home from "./components/Home";
import Gallery from "./components/Gallery";
import UserGallery from "./components/UserGallery";
import ProjectExplorer from "./components/ProjectExplorer";
import Requestdel from "./components/Requestdel";

Vue.use(VueRouter);

const routes = [
  {
    path: "/inicio",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: PasswordChange
  },
  {
    path: "/registro",
    name: "registro",
    component: Register
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy
  },
  {
    path: "/requestdel",
    name: "requestdel",
    component: Requestdel
  },    
  {
    path: "/compartir/:id",
    name: "compartir",
    component: CompartirMapa
  },
  {
    path: "/levantamientos/:id",
    name: "levantamientos",
    component: ExplorerMapUser,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/levProyecto/:id",
    name: "levantamientosPorProyecto",
    component: ExplorerProjectMapUser,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/support",
    name: "support",
    component: Support
  },
  {
    path: "/",
    component: Dashboard,
    name: "dashboard",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "/mapa",
        name: "mapa",
        component: Map,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/explorer",
        name: "explorer",
        component: ExplorerMap,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/gallery",
        name: "gallery",
        component: Gallery,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/users",
        name: "users",
        component: UserGallery,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/explora",
        name: "ProjectExplorer",
        component: ProjectExplorer,
        meta: {
          requiresAuth: true
        }
      },
      /*             {
                            path: "/cuestionarios",
                            component: FormList,
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/cuestionarios/nuevo",
                            component: FormBuilder,
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/cuestionarios/editar/:id",
                            component: FormEditBuilder,
                            name: "editarCuestionario",
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/cuestionarios/respuestas/:id",
                            component: FormAnswers,
                            name: "respuestasCuestionario",
                            meta: {
                                requiresAuth: true
                            }
                        }, */
      {
        path: "/userList",
        component: UserList,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/guestUserList",
        component: GuestUserList,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      /*             {
                            path: "/monitorsList",
                            component: MonitorsList,
                            meta: {
                                requiresAuth: true,
                                permission: "admin"
                            }
                        },
                        {
                            path: "/lugares",
                            component: PlacesList,
                            meta: {
                                permission: "admin",
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/eventos",
                            component: EventsList,
                            meta: {
                                permission: "admin",
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/quejas",
                            component: ComplaintsList,
                            meta: {
                                requiresAuth: true
                            }
                        }, */
      /*             {
                            path: "/reportes",
                            component: Reports,
                            meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/configuracion",
                            component: Config,
                            meta: {
                                permission: "admin",
                                requiresAuth: true
                            }
                        },
                        {
                            path: "/alertas",
                            component: AlertList,
                            meta: {
                                requiresAuth: true
                            }
                        }, */
      {
        path: "/raising",
        component: RaisingList,
        name: "viewRaisingEvaluation",
        meta: {
          requiresAuth: true,
          permission: "curador",
          is_admin: true
        }
      },
      {
        path: "/userRaising",
        component: UserRaisingList,
        name: "viewRaising",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      // {
      //     path: "/userRaising/:id",
      //     component: UserRaisingList,
      //     props: true,
      //     meta: {
      //         requiresAuth: true,
      //         is_admin: true
      //     }
      // },
      {
        path: "/estadisticas",
        component: LevantamientosStatistics,
        meta: {
          permission: "admin",
          requiresAuth: true
        }
      },
      {
        path: "/estadisticasUser",
        component: LevantamientosStatisticsUser,
        meta: {
          //permission: "admin",
          requiresAuth: true
        }
      },
      {
        path: "/proyectos",
        component: ProjectsList,
        name: "viewProject",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      {
        path: "/proyectosTodos",
        component: ProjectsListAll,
        name: "viewProjectAll",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      // {
      //     path: "/proyectos/:id",
      //     component: ProjectsList,

      //     meta: {
      //         requiresAuth: true,
      //         is_admin: true
      //     }
      // },
      {
        path: "/projectEvaluation",
        component: ProjectEvalueList,
        name: "viewProjectEvaluation",
        meta: {
          requiresAuth: true,
          permission: "curador",
          is_admin: true
        }
      },
      {
        path: "/download",
        component: DownloadList,
        name: "viewDownload",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      {
        path: "/downloadEvaluation",
        component: DownloadEvaluationList,
        meta: {
          requiresAuth: true,
          permission: "curador",
          is_admin: true
        }
      },
      {
        path: "/estadisticasUser",
        component: LevantamientosStatisticsUser,
        meta: {
          //permission: "admin",
          requiresAuth: true
        }
      },
      {
        path: "/proyectos",
        component: ProjectsList,
        name: "viewProject",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      {
        path: "/proyectosTodos",
        component: ProjectsListAll,
        name: "viewProjectAll",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      // {
      //     path: "/proyectos/:id",
      //     component: ProjectsList,

      //     meta: {
      //         requiresAuth: true,
      //         is_admin: true
      //     }
      // },
      {
        path: "/projectEvaluation",
        component: ProjectEvalueList,
        meta: {
          requiresAuth: true,
          permission: "curador",
          is_admin: true
        }
      },
      {
        path: "/download",
        component: DownloadList,
        name: "viewDownload",
        meta: {
          requiresAuth: true,
          is_admin: true
        }
      },
      {
        path: "/downloadEvaluation",
        component: DownloadEvaluationList,
        meta: {
          requiresAuth: true,
          permission: "curador",
          is_admin: true
        }
      }
    ]
  }
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem("accessToken")) {
    next({ name: "login", query: { next: to.path } });
  } else {
    if (to.fullPath == "/") {
      next({ name: "explorer" });
    } else {
      if (
        to.meta.permission == "admin" &&
        localStorage.getItem("category") != "ADMINISTRADOR"
      ) {
        next({ name: "explorer" });
      } else if (
        to.meta.permission == "curador" &&
        localStorage.getItem("category") != "REVISOR" &&
        to.meta.is_admin == true &&
        localStorage.getItem("category") != "ADMINISTRADOR"
      ) {
        next({ name: "explorer" });
      } else if (
        to.meta.permission == "lider de proyecto" &&
        localStorage.getItem("category") != "lider de proyecto" &&
        to.meta.is_admin == true &&
        localStorage.getItem("category") != "ADMINISTRADOR"
      ) {
        next({ name: "explorer" });
      } else {
        next();
      }
    }
  }
});

export default router;
